import PropTypes from "prop-types";
import { useEffect, useId, useState } from "react";

import { Switch as SwitchComponent } from "antd";
import classnames from "classnames";
import { MdLock } from "react-icons/md";
import Label from "shared/components/Label";

const Switch = ({
  label,
  placeholder,
  icon,
  innerRef,
  required,
  optional,
  checkedChildren,
  unCheckedChildren,
  errors,
  touched,
  onChange,
  checked,
  defaultChecked,
  id: idProp,
  ...rest
}) => {
  const generatedId = `switch-${useId().replace(/:/g, "")}`;
  const controlId = idProp ?? generatedId;

  const isControlled = checked !== undefined;

  // Tracker l'état du toggle pour mettre à jour le style du label
  const [isChecked, setIsChecked] = useState(
    checked ?? defaultChecked ?? false,
  );

  // Mettre à jour si la prop checked ou defaultChecked change
  useEffect(() => {
    if (checked !== undefined) {
      setIsChecked(checked);
    } else if (defaultChecked !== undefined) {
      setIsChecked(defaultChecked);
    }
  }, [checked, defaultChecked]);

  const hasRequiredError = required && !isChecked && (touched || errors);

  // Handler pour mettre à jour l'état local + appeler onChange parent
  const handleChange = (newChecked) => {
    if (!isControlled) {
      setIsChecked(newChecked);
    }
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <div
      className={classnames("switch__wrapper", {
        "switch--required-error": hasRequiredError,
        "switch--disabled": rest.disabled,
        "switch--unchecked": !isChecked && !rest.disabled,
      })}
    >
      <Label
        id={controlId}
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className="switch__control">
        <SwitchComponent
          className={classnames("button__switch", {
            "disable--input": rest.disabled,
          })}
          ref={innerRef}
          {...rest}
          id={controlId}
          checked={isChecked}
          onChange={handleChange}
        />
        {rest.disabled && <MdLock size={16} className="switch__lock-icon" />}
      </div>
    </div>
  );
};

Switch.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
};

Switch.defaultProps = {
  label: "",
};

export default Switch;
